import { render, staticRenderFns } from "./type.vue?vue&type=template&id=065df338"
import script from "./type.vue?vue&type=script&lang=js"
export * from "./type.vue?vue&type=script&lang=js"
import style0 from "./type.vue?vue&type=style&index=0&id=065df338&lang=scss"
import style1 from "./type.vue?vue&type=style&index=1&id=065df338&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065df338')) {
      api.createRecord('065df338', component.options)
    } else {
      api.reload('065df338', component.options)
    }
    module.hot.accept("./type.vue?vue&type=template&id=065df338", function () {
      api.rerender('065df338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/games/type.vue"
export default component.exports